import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getFarmDetail, editFarm } from '../../../actions/farmsActions'
import { getOrigens } from '../../../actions/origensActions'
import FormFarm from '../../admin/farms/FormFarm'
import Swal from 'sweetalert2'

export default function FarmEdit() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {farm} = useSelector(state=>state.farms)
    const {origens} = useSelector(state=>state.origens)
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {name, origen, latitude, longitude, idFarm} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleEdit = async(e) => {
        e.preventDefault()

        dispatch(editFarm(name, origen, latitude, longitude, idFarm))
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('farms.messageedit')
        })
    }

    useEffect(()=>{
        dispatch(getFarmDetail(id))
        dispatch(getOrigens())
    }, [dispatch,id])

    useEffect(() => {
        if (farm) {
            setFormState({
                name: farm.name,
                origen: farm.origen,
                latitude: farm.latitude,
                longitude: farm.longitude,
                idFarm: farm._id
            })
        }
    }, [farm, dispatch, id])
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/farms`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('farms.volver')}
                    </Button>
                </Row>
                <h1>{t('farms.name')}: <span className='text-uppercase'>{farm?.name}</span></h1>
                <FormFarm submit={handleEdit} isNew={false} inputChange={handleInputChange} state={formState} origens={origens}></FormFarm>
            </Row>
        </Container>
    )
}
